import React, { FC } from "react"
import { RoundedRectangle } from "../../atoms/roundedrectangle/RoundedRectangle"
import { CarrotCardModuleProps } from "components/views/molecules/CarrotCardModuleContainer"
import { CenteredLoadingIndicator } from "components/views/molecules/Molecules"

const CarrotCardLoadingModule: FC<CarrotCardModuleProps> = ({ backgroundColor }) => (
  <RoundedRectangle backgroundColor={backgroundColor}>
    <CenteredLoadingIndicator />
  </RoundedRectangle>
)

export { CarrotCardLoadingModule }
